<div
  class="file-preview-card"
  [style.--file-preview-width]="$previewWidth()"
  [style.--file-preview-height]="$previewHeight()"
  [tuiHint]="$title()"
  tuiHintAppearance="dark"
  tuiHintDirection="top-start"
>
  @if ($badge(); as badge) {
    <span class="file-preview-badge">{{ badge }}</span>
  }
  @if ($showFallbackIcon() && $fallbackIcon(); as fallbackIcon) {
    <div class="file-preview-icon" aria-hidden="true">
      <tui-icon [icon]="fallbackIcon"></tui-icon>
    </div>
  } @else {
    <img [src]="$currentSrc()" [alt]="$title()" (error)="onImgError()" />
  }
</div>
